var React = require('react');

function SearchIconWhite (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14","cy":"14","r":"13","stroke":"#FFFFFF","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M32.6464 33.3536C32.8417 33.5488 33.1583 33.5488 33.3536 33.3536C33.5488 33.1583 33.5488 32.8417 33.3536 32.6464L32.6464 33.3536ZM33.3536 32.6464L23.3536 22.6464L22.6464 23.3536L32.6464 33.3536L33.3536 32.6464Z","fill":"#FFFFFF","key":1})]);
}

SearchIconWhite.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = SearchIconWhite;

SearchIconWhite.default = SearchIconWhite;
